/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdWebFeaturesPlayGameResponseMobileGameOrientationFromJSON, FxIdWebFeaturesPlayGameResponseMobileGameOrientationToJSON, } from './FxIdWebFeaturesPlayGameResponseMobileGameOrientation';
import { FxIdDomainSettingsUrlOpenMethodFromJSON, FxIdDomainSettingsUrlOpenMethodToJSON, } from './FxIdDomainSettingsUrlOpenMethod';
import { FxIdDomainSettingsEGameOrientationFromJSON, FxIdDomainSettingsEGameOrientationToJSON, } from './FxIdDomainSettingsEGameOrientation';
import { FxIdWebFeaturesPlayGameResponseSupportFromJSON, FxIdWebFeaturesPlayGameResponseSupportToJSON, } from './FxIdWebFeaturesPlayGameResponseSupport';
import { FxIdApplicationPublicDataBuilderPlatformDataOptionsFromJSON, FxIdApplicationPublicDataBuilderPlatformDataOptionsToJSON, } from './FxIdApplicationPublicDataBuilderPlatformDataOptions';
import { FxIdWebFeaturesPlayGameResponseFxLauncherOptionsFromJSON, FxIdWebFeaturesPlayGameResponseFxLauncherOptionsToJSON, } from './FxIdWebFeaturesPlayGameResponseFxLauncherOptions';
import { FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsFromJSON, FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsToJSON, } from './FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions';
import { FxIdDomainSettingsPublicWebClientConfigOptionsFromJSON, FxIdDomainSettingsPublicWebClientConfigOptionsToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptions';
import { FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsFromJSON, FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsToJSON, } from './FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions';
import { FxIdDomainEntitiesPlayGameTypeFromJSON, FxIdDomainEntitiesPlayGameTypeToJSON, } from './FxIdDomainEntitiesPlayGameType';
import { FxIdWebFeaturesPlayGameResponseAuthFromJSON, FxIdWebFeaturesPlayGameResponseAuthToJSON, } from './FxIdWebFeaturesPlayGameResponseAuth';
import { FxIdWebFeaturesPlayGameResponsePresentationFromJSON, FxIdWebFeaturesPlayGameResponsePresentationToJSON, } from './FxIdWebFeaturesPlayGameResponsePresentation';
import { FxIdWebFeaturesPlayGameResponseStatisticsFromJSON, FxIdWebFeaturesPlayGameResponseStatisticsToJSON, } from './FxIdWebFeaturesPlayGameResponseStatistics';
/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPublicDataBase interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPublicDataBase(value) {
    if (!('PlayGameType' in value) || value['PlayGameType'] === undefined)
        return false;
    if (!('PlatformData' in value) || value['PlatformData'] === undefined)
        return false;
    if (!('GameOrientation' in value) || value['GameOrientation'] === undefined)
        return false;
    if (!('MobileGameOrientation' in value) || value['MobileGameOrientation'] === undefined)
        return false;
    if (!('SupportedLanguages' in value) || value['SupportedLanguages'] === undefined)
        return false;
    if (!('DefaultLanguage' in value) || value['DefaultLanguage'] === undefined)
        return false;
    if (!('Store' in value) || value['Store'] === undefined)
        return false;
    if (!('Turnstile' in value) || value['Turnstile'] === undefined)
        return false;
    if (!('CompanyName' in value) || value['CompanyName'] === undefined)
        return false;
    if (!('TosUrl' in value) || value['TosUrl'] === undefined)
        return false;
    if (!('TosUrlOpenMethod' in value) || value['TosUrlOpenMethod'] === undefined)
        return false;
    if (!('PpUrl' in value) || value['PpUrl'] === undefined)
        return false;
    if (!('PpUrlOpenMethod' in value) || value['PpUrlOpenMethod'] === undefined)
        return false;
    if (!('PublicWebClientConfig' in value) || value['PublicWebClientConfig'] === undefined)
        return false;
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined)
        return false;
    if (!('NamespacedProductsL10N' in value) || value['NamespacedProductsL10N'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'PlayGameType': FxIdDomainEntitiesPlayGameTypeFromJSON(json['PlayGameType']),
        'PlatformData': FxIdApplicationPublicDataBuilderPlatformDataOptionsFromJSON(json['PlatformData']),
        'Statistics': json['Statistics'] == null ? undefined : FxIdWebFeaturesPlayGameResponseStatisticsFromJSON(json['Statistics']),
        'GameOrientation': FxIdDomainSettingsEGameOrientationFromJSON(json['GameOrientation']),
        'MobileGameOrientation': FxIdWebFeaturesPlayGameResponseMobileGameOrientationFromJSON(json['MobileGameOrientation']),
        'Presentation': json['Presentation'] == null ? undefined : FxIdWebFeaturesPlayGameResponsePresentationFromJSON(json['Presentation']),
        'MobilePresentation': json['MobilePresentation'] == null ? undefined : FxIdWebFeaturesPlayGameResponsePresentationFromJSON(json['MobilePresentation']),
        'ViewportPresentation': json['ViewportPresentation'] == null ? undefined : FxIdWebFeaturesPlayGameResponsePresentationFromJSON(json['ViewportPresentation']),
        'SupportedLanguages': json['SupportedLanguages'],
        'DefaultLanguage': json['DefaultLanguage'],
        'Support': json['Support'] == null ? undefined : FxIdWebFeaturesPlayGameResponseSupportFromJSON(json['Support']),
        'Store': FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsFromJSON(json['Store']),
        'FxLauncherOptions': json['FxLauncherOptions'] == null ? undefined : FxIdWebFeaturesPlayGameResponseFxLauncherOptionsFromJSON(json['FxLauncherOptions']),
        'Turnstile': FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsFromJSON(json['Turnstile']),
        'CompanyName': json['CompanyName'],
        'TosUrl': json['TosUrl'],
        'TosUrlOpenMethod': FxIdDomainSettingsUrlOpenMethodFromJSON(json['TosUrlOpenMethod']),
        'PpUrl': json['PpUrl'],
        'PpUrlOpenMethod': FxIdDomainSettingsUrlOpenMethodFromJSON(json['PpUrlOpenMethod']),
        'PublicWebClientConfig': FxIdDomainSettingsPublicWebClientConfigOptionsFromJSON(json['PublicWebClientConfig']),
        'Auth': json['Auth'] == null ? undefined : FxIdWebFeaturesPlayGameResponseAuthFromJSON(json['Auth']),
        'GameSystemName': json['GameSystemName'],
        'NamespacedProductsL10N': json['NamespacedProductsL10N'],
    };
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseToJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'PlayGameType': FxIdDomainEntitiesPlayGameTypeToJSON(value['PlayGameType']),
        'PlatformData': FxIdApplicationPublicDataBuilderPlatformDataOptionsToJSON(value['PlatformData']),
        'Statistics': FxIdWebFeaturesPlayGameResponseStatisticsToJSON(value['Statistics']),
        'GameOrientation': FxIdDomainSettingsEGameOrientationToJSON(value['GameOrientation']),
        'MobileGameOrientation': FxIdWebFeaturesPlayGameResponseMobileGameOrientationToJSON(value['MobileGameOrientation']),
        'Presentation': FxIdWebFeaturesPlayGameResponsePresentationToJSON(value['Presentation']),
        'MobilePresentation': FxIdWebFeaturesPlayGameResponsePresentationToJSON(value['MobilePresentation']),
        'ViewportPresentation': FxIdWebFeaturesPlayGameResponsePresentationToJSON(value['ViewportPresentation']),
        'SupportedLanguages': value['SupportedLanguages'],
        'DefaultLanguage': value['DefaultLanguage'],
        'Support': FxIdWebFeaturesPlayGameResponseSupportToJSON(value['Support']),
        'Store': FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsToJSON(value['Store']),
        'FxLauncherOptions': FxIdWebFeaturesPlayGameResponseFxLauncherOptionsToJSON(value['FxLauncherOptions']),
        'Turnstile': FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsToJSON(value['Turnstile']),
        'CompanyName': value['CompanyName'],
        'TosUrl': value['TosUrl'],
        'TosUrlOpenMethod': FxIdDomainSettingsUrlOpenMethodToJSON(value['TosUrlOpenMethod']),
        'PpUrl': value['PpUrl'],
        'PpUrlOpenMethod': FxIdDomainSettingsUrlOpenMethodToJSON(value['PpUrlOpenMethod']),
        'PublicWebClientConfig': FxIdDomainSettingsPublicWebClientConfigOptionsToJSON(value['PublicWebClientConfig']),
        'Auth': FxIdWebFeaturesPlayGameResponseAuthToJSON(value['Auth']),
        'GameSystemName': value['GameSystemName'],
        'NamespacedProductsL10N': value['NamespacedProductsL10N'],
    };
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPublicDataBase.js.map